import endpoints from "../config/apiConfig";
import axiosInstance from "../config/axiosInstance";
import { CreateDocumentPayloadType, DeleteDocumentPayload } from "../types/model";

const createCustomerDocument = (payload: CreateDocumentPayloadType) => {
  return axiosInstance.post(endpoints.createCustomerDocument, payload);
};

const updateCustomerDocument = (procedureUUID: string) => {
  return axiosInstance.get(
    `${endpoints.updateCustomerDocument}/${procedureUUID}`
  );
};

const getDocuments = (caseId: string) => {
  return axiosInstance.get(`${endpoints.getDocuments}/${caseId}?type=image`);
};
const getConsultationDocuments = (caseId: string) => {
  return axiosInstance.get(
    `${endpoints.getConsultationDocuments}/${caseId}?type=image`
  );
};
const getSessionDocuments = (sessionId: string) => {
  return axiosInstance.get(
    `${endpoints.getSessionDocuments}/${sessionId}?type=image`
  );
};
const getSingleDocument = (uuid: string) => {
  return axiosInstance.get(`${endpoints.getSingleDocument}/${uuid}`);
};
const deleteDocument = (payload: DeleteDocumentPayload) => {
  return axiosInstance.post(`${endpoints.deleteDocument}`, payload);
};

export {
  createCustomerDocument,
  updateCustomerDocument,
  getDocuments,
  deleteDocument,
  getConsultationDocuments,
  getSessionDocuments,
  getSingleDocument,
};
